import type { EditorView } from '@tiptap/pm/view';
import { insertImageFile } from './insert-image-file';

/**
 * Inserts pasted clipboard images (screenshots, copied files) as base64 data URLs.
 * ProseMirror only handles HTML/text by default, so file items would otherwise be dropped.
 */
export const handleImagePaste = (view: EditorView, event: ClipboardEvent, isEditorAlive: () => boolean): boolean => {
  const items = event.clipboardData?.items;
  if (!items) {
    return false;
  }

  for (const item of items) {
    const isImageFile = item.kind === 'file' && item.type.startsWith('image/');
    if (!isImageFile) {
      continue;
    }

    const file = item.getAsFile();
    if (!file) {
      continue;
    }

    event.preventDefault();
    insertImageFile(view, file, isEditorAlive);
    return true;
  }

  return false;
};
